// extracted by mini-css-extract-plugin
export default {"root":"_1xr5n","first-row":"_3xHmf","firstRow":"_3xHmf","second-row":"_3aJAb","secondRow":"_3aJAb"};